import { render, staticRenderFns } from "./InstitutionProvider.vue?vue&type=template&id=5e8c1405"
import script from "./InstitutionProvider.vue?vue&type=script&lang=js"
export * from "./InstitutionProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports